import * as i0 from '@angular/core';
import { Injectable, Component, ViewChild, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import moment from 'moment';
import * as i2 from 'primeng/table';
import * as i3 from 'primeng/api';
import * as i4 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class LibEvaluationDetailsService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getEvaluationDetails() {
        return this.http.get(`/vd/formBuilder/invoice/invoiceNumber?type=RECEIPT`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getJobposition(applicantId) {
        return this.http.get(`/vd/fb/get/talentAcq/taEvaluationDetails/${applicantId}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    getCandidateDetails(candidateId, applicantClientJobPositionsId) {
        const params = {};
        if (applicantClientJobPositionsId !== null && applicantClientJobPositionsId !== undefined) {
            params.applicantClientJobPositionsId = applicantClientJobPositionsId.toString();
        }
        return this.http.get(`/vd/formBuilder/get/applicant/${candidateId}/info`, { params }).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibEvaluationDetailsService.ɵfac = function LibEvaluationDetailsService_Factory(t) { return new (t || LibEvaluationDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
LibEvaluationDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: LibEvaluationDetailsService, factory: LibEvaluationDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibEvaluationDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["dt"];
function LibEvaluationDetailsComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "th", 15);
    i0.ɵɵelementStart(2, "th");
    i0.ɵɵtext(3, "Job ID/Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th");
    i0.ɵɵtext(5, "Applicant Id");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Job Position");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Client");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "Recruiter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵtext(13, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th");
    i0.ɵɵtext(15, "Application Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "th");
    i0.ɵɵtext(17, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibEvaluationDetailsComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 15);
    i0.ɵɵelementStart(2, "button", 16);
    i0.ɵɵlistener("click", function LibEvaluationDetailsComponent_ng_template_9_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r12); const details_r10 = ctx.$implicit; const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.toggleRow(details_r10); });
    i0.ɵɵelement(3, "i", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "td");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r10 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !details_r10.fbApplicantInterviewResultsDTOList || details_r10.fbApplicantInterviewResultsDTOList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", details_r10.isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(details_r10.jobId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(details_r10.applicantClientId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(details_r10.jobPosition);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(details_r10.client);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(details_r10.recruiter[0]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(details_r10.location);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(18, 10, details_r10.applicationDate, "MM/dd/yyyy"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(details_r10.result);
} }
function LibEvaluationDetailsComponent_ng_template_10_div_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 25);
} }
function LibEvaluationDetailsComponent_ng_template_10_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function LibEvaluationDetailsComponent_ng_template_10_div_3_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r21); const i_r18 = ctx.index; const ctx_r20 = i0.ɵɵnextContext(3); return ctx_r20.onStepLabelClick(i_r18); });
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LibEvaluationDetailsComponent_ng_template_10_div_3_div_1_div_5_Template, 1, 0, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r17 = ctx.$implicit;
    const i_r18 = ctx.index;
    const details_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", i_r18 === ctx_r16.currentStep);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r18 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(step_r17.accordionName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r18 < details_r13.fbApplicantInterviewResultsDTOList.length - 1);
} }
function LibEvaluationDetailsComponent_ng_template_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, LibEvaluationDetailsComponent_ng_template_10_div_3_div_1_Template, 6, 5, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", details_r13.fbApplicantInterviewResultsDTOList);
} }
function LibEvaluationDetailsComponent_ng_template_10_div_4_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 2);
    i0.ɵɵelementStart(3, "h5", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 30);
    i0.ɵɵelementStart(6, "div", 31);
    i0.ɵɵtext(7, "Interviewer");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 32);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 30);
    i0.ɵɵelementStart(11, "div", 31);
    i0.ɵɵtext(12, "Interview Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 32);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 30);
    i0.ɵɵelementStart(16, "div", 31);
    i0.ɵɵtext(17, "Interview Time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 32);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 30);
    i0.ɵɵelementStart(21, "div", 31);
    i0.ɵɵtext(22, "Mode of Interview");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 32);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 30);
    i0.ɵɵelementStart(26, "div", 31);
    i0.ɵɵtext(27, "Meeting Link");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 32);
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 33);
    i0.ɵɵelementStart(31, "div", 2);
    i0.ɵɵelementStart(32, "h5", 3);
    i0.ɵɵtext(33, "Result Updates");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 34);
    i0.ɵɵelementStart(35, "div", 31);
    i0.ɵɵtext(36, "Did the interview happen?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 32);
    i0.ɵɵtext(38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 34);
    i0.ɵɵelementStart(40, "div", 31);
    i0.ɵɵtext(41, "Interview Result");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 32);
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 34);
    i0.ɵɵelementStart(45, "div", 31);
    i0.ɵɵtext(46, "Rating");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "div", 32);
    i0.ɵɵtext(48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 35);
    i0.ɵɵelementStart(50, "div", 31);
    i0.ɵɵtext(51, "Remarks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "div", 32);
    i0.ɵɵtext(53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const job_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(job_r25.accordionName);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.interviewerName ? job_r25.interviewerName : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.interviewDate ? job_r25.interviewDate : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.interviewTime ? job_r25.interviewTime : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.modeOfInterview ? job_r25.modeOfInterview : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.meetingLink ? job_r25.meetingLink : "NA");
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(job_r25.interviewHappened ? "Yes" : "No");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.interviewResult ? job_r25.interviewResult : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.interviewRating ? job_r25.interviewRating : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(job_r25.interviewRemarks ? job_r25.interviewRemarks : "NA");
} }
function LibEvaluationDetailsComponent_ng_template_10_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LibEvaluationDetailsComponent_ng_template_10_div_4_ng_container_1_div_1_Template, 54, 10, "div", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r26 = ctx.index;
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r26 === ctx_r24.currentStep);
} }
function LibEvaluationDetailsComponent_ng_template_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, LibEvaluationDetailsComponent_ng_template_10_div_4_ng_container_1_Template, 2, 1, "ng-container", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", details_r13.fbApplicantInterviewResultsDTOList);
} }
function LibEvaluationDetailsComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 18);
    i0.ɵɵelementStart(2, "div", 10);
    i0.ɵɵtemplate(3, LibEvaluationDetailsComponent_ng_template_10_div_3_Template, 2, 1, "div", 11);
    i0.ɵɵtemplate(4, LibEvaluationDetailsComponent_ng_template_10_div_4_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r13 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", details_r13.fbApplicantInterviewResultsDTOList.length !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", details_r13.fbApplicantInterviewResultsDTOList && details_r13.fbApplicantInterviewResultsDTOList.length > 0);
} }
function LibEvaluationDetailsComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "No records found");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 9);
} }
function LibEvaluationDetailsComponent_div_15_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 25);
} }
function LibEvaluationDetailsComponent_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function LibEvaluationDetailsComponent_div_15_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r36); const i_r33 = ctx.index; const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.onStepLabelClick(i_r33); });
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LibEvaluationDetailsComponent_div_15_div_1_div_5_Template, 1, 0, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r33 = ctx.index;
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("active", i_r33 === ctx_r31.currentStep);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r33 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r31.JobpositionList[i_r33] == null ? null : ctx_r31.JobpositionList[i_r33].accordionName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r33 < ctx_r31.JobpositionList.length - 1);
} }
function LibEvaluationDetailsComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, LibEvaluationDetailsComponent_div_15_div_1_Template, 6, 5, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.JobpositionList);
} }
function LibEvaluationDetailsComponent_div_16_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 2);
    i0.ɵɵelementStart(3, "h5", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 30);
    i0.ɵɵelementStart(6, "div", 31);
    i0.ɵɵtext(7, " Interviewer ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 32);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 30);
    i0.ɵɵelementStart(11, "div", 31);
    i0.ɵɵtext(12, " Interviewe Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 32);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 30);
    i0.ɵɵelementStart(16, "div", 31);
    i0.ɵɵtext(17, " Interview Time ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 32);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 30);
    i0.ɵɵelementStart(21, "div", 31);
    i0.ɵɵtext(22, " Mode of Interview ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 32);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 30);
    i0.ɵɵelementStart(26, "div", 31);
    i0.ɵɵtext(27, " Meeting Link ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 32);
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 33);
    i0.ɵɵelementStart(31, "div", 2);
    i0.ɵɵelementStart(32, "h5", 3);
    i0.ɵɵtext(33, "Result Updates");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 34);
    i0.ɵɵelementStart(35, "div", 31);
    i0.ɵɵtext(36, " Did the interview happen? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 32);
    i0.ɵɵtext(38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 34);
    i0.ɵɵelementStart(40, "div", 31);
    i0.ɵɵtext(41, " Interview Result ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 32);
    i0.ɵɵtext(43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 34);
    i0.ɵɵelementStart(45, "div", 31);
    i0.ɵɵtext(46, " Rating ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "div", 32);
    i0.ɵɵtext(48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(49, "div", 35);
    i0.ɵɵelementStart(50, "div", 31);
    i0.ɵɵtext(51, " Remarks ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "div", 32);
    i0.ɵɵtext(53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const job_r38 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(job_r38 == null ? null : job_r38.accordionName);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.interviewerName) ? job_r38 == null ? null : job_r38.interviewerName : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.interviewDate) ? job_r38 == null ? null : job_r38.interviewDate : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.interviewTime) ? job_r38 == null ? null : job_r38.interviewTime : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.modeOfInterview) ? job_r38 == null ? null : job_r38.modeOfInterview : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.meetingLink) ? job_r38 == null ? null : job_r38.meetingLink : "NA", " ");
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.interviewHappened) ? "Yes" : "No", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.interviewResult) ? job_r38 == null ? null : job_r38.interviewResult : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.interviewRating) ? job_r38 == null ? null : job_r38.interviewRating : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (job_r38 == null ? null : job_r38.interviewRemarks) ? job_r38 == null ? null : job_r38.interviewRemarks : "NA", " ");
} }
function LibEvaluationDetailsComponent_div_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LibEvaluationDetailsComponent_div_16_ng_container_1_div_1_Template, 54, 10, "div", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r39 = ctx.index;
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r39 === ctx_r37.currentStep);
} }
function LibEvaluationDetailsComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, LibEvaluationDetailsComponent_div_16_ng_container_1_Template, 2, 1, "ng-container", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r6.JobpositionList);
} }
function LibEvaluationDetailsComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Job ID/Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Job Position");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Client");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Recruiter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Result");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibEvaluationDetailsComponent_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r42 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r42.jobId, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r42.jobPosition, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r42.client, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r42.recruiter[0], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r42.location, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", details_r42.result, " ");
} }
function LibEvaluationDetailsComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, " No records found ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 3);
} }
class LibEvaluationDetailsComponent {
    constructor(libEvaluationDetailsService, cdr) {
        this.libEvaluationDetailsService = libEvaluationDetailsService;
        this.cdr = cdr;
        this.observableSubscription$ = new Subject();
        this.currentStep = 0;
        this.pastPositionDetails = [];
        this.openPositionDetails = [];
        this.JobpositionList = [];
        this.isExpanded = false;
    }
    ngOnInit() {
        this.getCandidateDetails();
    }
    getLatestRowID() {
        const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO'));
        return fbFormDataDTO[fbFormDataDTO.length - 1].id;
    }
    getCandidateDetails() {
        this.candidateId = 'applicantId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantId')) : 'fbFormDataDTO' in sessionStorage ? this.getLatestRowID() : null;
        this.applicantInfoId = 'applicantInfoId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantInfoId')) : null;
        if (this.candidateId) {
            this.libEvaluationDetailsService.getCandidateDetails(this.candidateId, this.applicantInfoId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                var _a;
                this.candidateDetails = response.data.applicantInfo;
                this.applicantId = (_a = response.data.educationList[0]) === null || _a === void 0 ? void 0 : _a.applicantInfoId;
                if (this.applicantId) {
                    this.libEvaluationDetailsService
                        .getJobposition(this.applicantId)
                        .pipe(takeUntil(this.observableSubscription$))
                        .subscribe((response) => {
                        var _a, _b, _c, _d, _e;
                        this.jobdetail = response === null || response === void 0 ? void 0 : response.data;
                        this.JobpositionList = ((_a = this.jobdetail) === null || _a === void 0 ? void 0 : _a.fbApplicantInterviewResultsDTO) ? (_b = this.jobdetail) === null || _b === void 0 ? void 0 : _b.fbApplicantInterviewResultsDTO : [];
                        this.pastPositionDetails = ((_c = this.jobdetail) === null || _c === void 0 ? void 0 : _c.pastPositionsDTOList) ? (_d = this.jobdetail) === null || _d === void 0 ? void 0 : _d.pastPositionsDTOList : null;
                        //this.openPositionDetails = this.jobdetail?.openPositionsDTOList ? this.jobdetail?.openPositionsDTOList : null;
                        this.openPositionDetails = ((_e = this.jobdetail) === null || _e === void 0 ? void 0 : _e.openPositionsDTOList) ? this.jobdetail.openPositionsDTOList.map(position => (Object.assign(Object.assign({}, position), { isExpanded: false, applicationDate: moment(position.applicationDate).format('MM/DD/YYYY') }))) : null;
                    });
                }
            });
        }
    }
    onStepLabelClick(index) {
        this.currentStep = index;
        this.cdr.detectChanges();
    }
    toggleRow(details) {
        details.isExpanded = !details.isExpanded;
        this.table.toggleRow(details);
    }
}
LibEvaluationDetailsComponent.ɵfac = function LibEvaluationDetailsComponent_Factory(t) { return new (t || LibEvaluationDetailsComponent)(i0.ɵɵdirectiveInject(LibEvaluationDetailsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
LibEvaluationDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibEvaluationDetailsComponent, selectors: [["lib-evaluation-details"]], viewQuery: function LibEvaluationDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.table = _t.first);
    } }, decls: 26, vars: 7, consts: [[1, "evaluation_details"], [1, "row"], [1, "col-12"], [1, "w-600"], ["styleClass", "p-datatable-gridlines", "dataKey", "jobId", 3, "value", "resizableColumns", "rowExpandMode"], ["dt", ""], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], ["pTemplate", "emptymessage"], [1, "custom-stepper"], ["class", "step-indicator", 4, "ngIf"], ["class", "step-content", 4, "ngIf"], [1, "row", "position-table"], ["styleClass", "p-datatable-gridlines", 3, "value", "resizableColumns"], [1, "arrow-column"], ["type", "button", 1, "icon-button", 3, "disabled", "click"], [3, "ngClass"], ["colspan", "9"], [1, "step-indicator"], ["class", "inactive", 3, "active", "click", 4, "ngFor", "ngForOf"], [1, "inactive", 3, "click"], [1, "step-number"], [1, "step-label"], ["class", "step-line", 4, "ngIf"], [1, "step-line"], [1, "step-content"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "row", "rounds_section", "mt-3"], [1, "col-3"], [1, "header"], [1, "context"], [1, "row", "result_updates", "mt-3", "mb-4"], [1, "col-12", "mb-2"], [1, "col-6", "mb-2"]], template: function LibEvaluationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5", 3);
        i0.ɵɵtext(4, "Open Positions");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵelementStart(6, "p-table", 4, 5);
        i0.ɵɵtemplate(8, LibEvaluationDetailsComponent_ng_template_8_Template, 18, 0, "ng-template", 6);
        i0.ɵɵtemplate(9, LibEvaluationDetailsComponent_ng_template_9_Template, 21, 13, "ng-template", 7);
        i0.ɵɵtemplate(10, LibEvaluationDetailsComponent_ng_template_10_Template, 5, 2, "ng-template", 8);
        i0.ɵɵtemplate(11, LibEvaluationDetailsComponent_ng_template_11_Template, 3, 1, "ng-template", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 1);
        i0.ɵɵelementStart(13, "div", 2);
        i0.ɵɵelementStart(14, "div", 10);
        i0.ɵɵtemplate(15, LibEvaluationDetailsComponent_div_15_Template, 2, 1, "div", 11);
        i0.ɵɵtemplate(16, LibEvaluationDetailsComponent_div_16_Template, 2, 1, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 13);
        i0.ɵɵelementStart(18, "div", 2);
        i0.ɵɵelementStart(19, "h5", 3);
        i0.ɵɵtext(20, "Past Positions");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 2);
        i0.ɵɵelementStart(22, "p-table", 14);
        i0.ɵɵtemplate(23, LibEvaluationDetailsComponent_ng_template_23_Template, 13, 0, "ng-template", 6);
        i0.ɵɵtemplate(24, LibEvaluationDetailsComponent_ng_template_24_Template, 13, 6, "ng-template", 7);
        i0.ɵɵtemplate(25, LibEvaluationDetailsComponent_ng_template_25_Template, 3, 1, "ng-template", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("value", ctx.openPositionDetails)("resizableColumns", true)("rowExpandMode", "single");
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.JobpositionList.length !== 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.JobpositionList && ctx.JobpositionList.length > 0);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("value", ctx.pastPositionDetails)("resizableColumns", true);
    } }, directives: [i2.Table, i3.PrimeTemplate, i4.NgIf, i4.NgClass, i4.NgForOf], pipes: [i4.DatePipe], styles: [".multiBtn[_ngcontent-%COMP%]{position:relative;right:16px;top:10px;float:right}.btnNext[_ngcontent-%COMP%]{margin-left:12px}.custom-stepper[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-top:18px}.step-indicator[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;margin-bottom:16px;width:100%;height:40px}.step-indicator[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:flex;align-items:center;align-self:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;transition:background-color .3s ease;margin:0 10px}.inactive[_ngcontent-%COMP%]   .step-number[_ngcontent-%COMP%]{background-color:#c3cbd4;border:2px solid #c3cbd4;color:#fff}.step-indicator[_ngcontent-%COMP%]   div.active[_ngcontent-%COMP%]   .step-number[_ngcontent-%COMP%]{background-color:#85d47a!important;border:2px solid #85d47a;color:#fff}.step-number[_ngcontent-%COMP%]{width:34px;height:34px;border-radius:50%;background-color:#fff;border:2px solid #85d47a;margin-right:-10px;display:flex;justify-content:center;align-items:center;color:#85d47a;font-weight:700}.step-label[_ngcontent-%COMP%]{margin-right:8px;position:relative;right:10px}.step-line[_ngcontent-%COMP%]{flex-grow:1;height:2px;width:50px;background-color:#c2c0c0;margin:0 8px}.position-table[_ngcontent-%COMP%]{margin-top:18px}.icon-button[_ngcontent-%COMP%]{cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;width:18px;height:14px}.arrow-column[_ngcontent-%COMP%]{width:50px;text-align:center}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibEvaluationDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-evaluation-details',
                templateUrl: "./lib-evaluation-details.component.html",
                styleUrls: ["./lib-evaluation-details.component.scss"],
            }]
    }], function () { return [{ type: LibEvaluationDetailsService }, { type: i0.ChangeDetectorRef }]; }, { table: [{
            type: ViewChild,
            args: ['dt']
        }] }); })();

class LibEvaluationDetailsModule {
}
LibEvaluationDetailsModule.ɵfac = function LibEvaluationDetailsModule_Factory(t) { return new (t || LibEvaluationDetailsModule)(); };
LibEvaluationDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibEvaluationDetailsModule });
LibEvaluationDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibEvaluationDetailsModule, { declarations: [LibEvaluationDetailsComponent], imports: [PrimengLibraryModule], exports: [LibEvaluationDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibEvaluationDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [LibEvaluationDetailsComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [LibEvaluationDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-evaluation-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibEvaluationDetailsComponent, LibEvaluationDetailsModule, LibEvaluationDetailsService };
//# sourceMappingURL=lib-evaluation-details.js.map
